registerComponent("sections/erro-404", function (component) {
/**
 * sections/erro-404 — a página de erro (ADR 0111 do site novo). TRÊS coisas,
 * todas só com movimento permitido; sem ele o CSS fica no estado final, inteiro
 * e parado:
 *
 * 1. revela o componente (`.is-in`, `Asa.revelar`), que só arma a varredura da
 *    luz do grafismo: nada mais entra (18/09 e 22/09, ver `_erro-404.less`);
 * 2. a TRANSIÇÃO DO MONOGRAMA ATÉ A BARRA, a mesma da home e de "Sobre o ASA"
 *    (`Asa.transicaoDoTopo`): a faixa vai do primeiro pixel de rolagem até o
 *    quadro em que o card encosta na base do header — a posição do card no
 *    documento menos a altura da barra. Medida pela caixa do CARD, que não é
 *    `sticky`: a posição de um `sticky` mente quando a página abre já rolada;
 * 3. no FIM da faixa marca `js-topo-encostado` no <html> — a barra, que era
 *    transparente para o gradiente e o grafismo passarem por baixo dela, ganha
 *    o fundo, o `.header__logo` acende e a assinatura apaga. As regras já
 *    existem em `_header-redesign.less`: a página só põe as classes
 *    `header--acima header--acima-celular`, como o `_topo-editorial.js` faz.
 *
 * @param {HTMLElement} component - elemento raiz do componente
 * @param {Object} params
 */

const painel = component.querySelector('.erro-404__painel');
const header = document.querySelector('.header');

if (Asa.movimentoPermitido() && painel) {
    Asa.revelar(component);

    const transicao = Asa.transicaoDoTopo(component, {
        medir: () => (painel.getBoundingClientRect().top + window.scrollY)
            - (header ? header.offsetHeight : 0),
        classeNativo: 'erro-404--nativo',
        propAlcance: '--erro-alcance',
        propInicio: '--erro-inicio',
        propT: '--erro-t',
    });

    const raiz = document.documentElement;

    Asa.aoRolar((y) => {
        const alcance = transicao.alcance();

        raiz.classList.toggle('js-topo-encostado', alcance > 0 && y >= alcance);
    });
}

});
